import { Success } from './SyncResult';
import { InProgress, SyncState } from './SyncState';

export interface Synchronizable {
  readonly name: string;
  syncState: SyncState;
}
export type ProgressRecorder = (description: string) => void;
export type SyncProcess = (progress: ProgressRecorder) => Promise<Success>;

export function update(synchronizable: Synchronizable, newState: SyncState): void {
  // Synchronizable is intended to maintain the current synchronization state of itself,
  // and so will regularly be mutated.
  // eslint-disable-next-line no-param-reassign
  synchronizable.syncState = newState;
}

export function updateInProgress(
  synchronizable: Synchronizable,
  promise: Promise<Success>,
  start: Date,
  description: string,
) {
  const inProgress: InProgress = {
    asOf: new Date(),
    description,
    promise,
    start,
  };
  update(synchronizable, inProgress);
}
